module.exports = __webpack_public_path__ + "static/media/gallery-26.48d42f5e.jpg";